import React from 'react';
import { Sun } from 'lucide-react';
import { BRAND } from '@/lib/constants';

export default function SeasonalBanner() {
  return (
    <div
      data-testid="seasonal-availability-banner"
      role="complementary"
      aria-label="Seasonal availability"
      className="sticky top-0 z-50 w-full bg-[hsl(var(--c-ink))] text-[hsl(var(--c-cream))] border-b-2 border-[hsl(var(--c-mango-yellow))]"
      style={{ minHeight: 'var(--banner-offset)' }}
    >
      <div className="mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-10 h-9 flex items-center justify-center gap-2 text-[11px] sm:text-xs font-bold uppercase tracking-[0.18em]">
        <Sun className="h-3.5 w-3.5 text-[hsl(var(--c-mango-yellow))] shrink-0" strokeWidth={2.5} aria-hidden="true" />
        <span className="hidden sm:inline truncate">{BRAND.bannerCopy}</span>
        <span className="sm:hidden truncate">Florida Mango Season — May through August</span>
      </div>
    </div>
  );
}
